import { Keyboard } from 'react-native';
import {
  BottomSheetContainer,
  createUseBottomSheetModal,
  KeyboardAvoiding,
  useSafeArea,
  useScreenSize,
} from '@banhala/ui-kit';
import { isIOS, isWeb } from 'shared/src/utils';
import { useUpdateFolder } from '../../../queries/useUpdateFolder';
import { FolderNameEditor } from '../components/FolderNameEditor';

export const useRenameFolderBottomSheet = createUseBottomSheetModal<
  { folderSno: number; folderName: string },
  { sno: number; initialTitle: string; coverImage: string | null }
>(({ confirm, cancel, param }) => {
  const { mutateAsync: updateFolder } = useUpdateFolder();
  const { bottom, top } = useSafeArea();
  const { height: screenHeight } = useScreenSize();

  const sheet = (
    <BottomSheetContainer
      onPressClose={() => {
        Keyboard.dismiss();
        cancel();
      }}
      minHeight={isIOS ? (screenHeight - bottom - top) / 3 : 0}
      title="서랍 이름 바꾸기"
    >
      <FolderNameEditor
        initialValue={param.initialTitle}
        validate={value => value.length > 0 && value !== param.initialTitle}
        onSubmit={async value => {
          await updateFolder({
            sno: param.sno,
            title: value,
            image: param.coverImage,
          });
          confirm({ folderSno: param.sno, folderName: value });
        }}
        onClose={cancel}
      />
    </BottomSheetContainer>
  );

  // 웹은 KeyboardAvoiding이 no-op(behavior=undefined)이면서 visualViewport 차이만큼
  // 하단에 여백을 만들어 시트가 화면 끝까지 안 닿음 → 웹에서는 래핑하지 않음.
  return isWeb ? sheet : <KeyboardAvoiding>{sheet}</KeyboardAvoiding>;
});
